// ago-2026 · Fase 2 — Celda informativa del consumo de ALTAS del mes contra el cupo del plan.
// Solo se pinta para super_admin en Entidades / Empresas. NO bloquea nada, NO cobra nada:
// el super_admin contacta a la entidad manualmente. El cupo y el umbral vienen del backend
// (derivados del plan), así que ajustar el plan cambia la celda sin tocar código.
// sep-2026 · Si el super_admin ajustó el cupo a mano, la celda lo dice: «2/200 (+50 este mes)»
// cuando el extra vence al cierre del mes, o «2/400 (personalizado)» cuando sustituye al plan.
export const CeldaAltasMes = ({ uso }) => {
  if (!uso) return <span className="text-slate-400">—</span>;
  if (uso.semaforo === "ilimitado") {
    return (
      <span data-testid={`altas-mes-${uso.entity_id}`}
            className="inline-flex items-center rounded-full border border-slate-200 bg-slate-50 px-2 py-0.5 text-xs font-medium text-slate-600">
        Ilimitado
      </span>
    );
  }
  const cls = uso.semaforo === "rojo"
    ? "border-red-300 bg-red-100 text-red-800"
    : uso.semaforo === "ambar"
      ? "border-amber-300 bg-amber-100 text-amber-900"
      : "border-slate-200 bg-slate-100 text-slate-700";
  const personalizado = uso.limite_personalizado !== null && uso.limite_personalizado !== undefined;
  const nota = uso.extra_mes > 0
    ? "ajustado este mes"
    : personalizado ? "personalizado" : "";
  const titulo = [
    `Altas de cliente del mes ${uso.periodo} · plan ${uso.plan_nombre}`,
    uso.cupo_plan >= 0 ? `Cupo del plan: ${uso.cupo_plan}` : null,
    personalizado ? `Límite personalizado: ${uso.limite_personalizado}` : null,
    uso.extra_mes > 0 ? `Límite total fijado para el mes: ${uso.cupo} (${uso.extra_mes} sobre lo incluido)` : null,
    uso.ajuste_motivo ? `Motivo: ${uso.ajuste_motivo}` : null,
  ].filter(Boolean).join(" · ");
  return (
    <span className="inline-flex items-center gap-1.5">
      <span data-testid={`altas-mes-${uso.entity_id}`}
            data-semaforo={uso.semaforo}
            title={titulo}
            className={`inline-flex items-center rounded-full border px-2 py-0.5 font-mono text-xs font-semibold tabular-nums ${cls}`}>
        {uso.usadas}/{uso.cupo}
      </span>
      {nota && (
        <span data-testid={`altas-mes-nota-${uso.entity_id}`}
              className="text-[10px] font-medium text-slate-500">({nota})</span>
      )}
    </span>
  );
};
